import React, { FC, useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { CoreUtils, TabBar } from '@nhl/nhl-breakaway-ui';

import { StandingsViewType, StandingsViewTypeLabel } from '../../enums';
import StandingsMessages from '../../messages';
import { StandingsSeason, StandingsTab } from '../../types';

import { getSortedViewTabs } from './utils';

type Props = {
    season: StandingsSeason;
    selectedViewType: StandingsViewType;
    wildcardIndicator: boolean;
};

const StandingsTabBar: FC<Props> = ({ season, selectedViewType, wildcardIndicator }) => {
    const navigate = useNavigate();
    const { date: dateFromUrl } = useParams();
    const intl = useIntl();

    const displayedViews = useMemo<Array<StandingsViewType>>(
        () => getSortedViewTabs(season, wildcardIndicator),
        [season, wildcardIndicator]
    );

    const selectedViewTypeIndex: number | undefined = displayedViews.indexOf(selectedViewType);

    if (!displayedViews.length || selectedViewTypeIndex === -1) {
        return null;
    }

    const tabs: Array<StandingsTab> = displayedViews.map((dv) => ({
        key: dv,
        label: CoreUtils.safeFormatMessage(intl, StandingsMessages.viewToggleOptions[StandingsViewTypeLabel[dv]]),
        ariaControlId: `${dv}-tabpanel`,
        link: `/standings/${dateFromUrl}/${dv}`,
    }));

    const onSelectTab = (tab: StandingsTab) => {
        navigate(tab.link);
    };

    return (
        <TabBar
            tabs={tabs}
            selectedTab={tabs.find((tab) => tab.key === selectedViewType) || tabs[0]}
            onChangeSelectedTab={onSelectTab}
        />
    );
};
export default StandingsTabBar;
